import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { ServerErrorPage } from "./server-error-page";
import { NotFoundPage } from "./not-found-page";

export function RouterErrorElement() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      return <NotFoundPage />;
    }
  }

  return <ServerErrorPage />;
}
